import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { ChooseLocation } from '@symphony-solo/domain/choose-location/src/lib/models';

export enum ScanQROrderActionTypes {
  GetChooseLocationForQrScanAction = '[ChooseLocation] GetChooseLocationForQrScanAction',
  GetChooseLocationForQrScanSuccessAction = '[ChooseLocation] GetChooseLocationForQrScanSuccess',
  GetChooseLocationForQrScanErrorAction = '[ChooseLocation] GetChooseLocationForQrScanError',
  GetLocationTimeslotForQrScanAction = '[ChooseLocation] GetLocationTimeslotForQrScanAction',
  GetLocationTimeslotForQrScanSuccessAction = '[ChooseLocation] GetLocationTimeslotForQrScanSuccess',
  GetLocationTimeslotForQrScanErrorAction = '[ChooseLocation] GetLocationTimeslotForQrScanError',
  GetLocationMenusForQrScanAction = '[ChooseLocation] GetLocationMenusForQrScanAction',
  GetLocationMenusForQrScanSuccessAction = '[ChooseLocation] GetLocationMenusForQrScanSuccess',
  GetLocationMenusForQrScanErrorAction = '[ChooseLocation] GetLocationMenusForQrScanError',
  ClearStateAction = '[ScanQROrder] ClearStateAction',

  SetSiteIDAction = '[ScanQROrder] SetSiteIDAction',
  SetOrderFromSiteAction = '[ScanQROrder] SetOrderFromSiteAction',
}

export const getChooseLocationAction = createAction(ScanQROrderActionTypes.GetChooseLocationForQrScanAction, props<{ siteId: string }>());

export const getChooseLocationSuccessAction = createAction(
  ScanQROrderActionTypes.GetChooseLocationForQrScanSuccessAction,
  props<{ chooseLocation: ChooseLocation[] }>()
);

export const getChooseLocationErrorAction = createAction(
  ScanQROrderActionTypes.GetChooseLocationForQrScanErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const getLocationTimeslotForQrScanAction = createAction(
  ScanQROrderActionTypes.GetLocationTimeslotForQrScanAction,
  props<{ locationID: string; orderDate: string }>()
);

export const getLocationTimeslotSuccessAction = createAction(ScanQROrderActionTypes.GetLocationTimeslotForQrScanSuccessAction);

export const getLocationTimeslotErrorAction = createAction(
  ScanQROrderActionTypes.GetLocationTimeslotForQrScanErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const ClearStateAction = createAction(ScanQROrderActionTypes.ClearStateAction, props<{ actionType: string }>());

export const setSiteIDAction = createAction(ScanQROrderActionTypes.SetSiteIDAction, props<{ siteId: string }>());

export const setOrderFromSiteAction = createAction(ScanQROrderActionTypes.SetOrderFromSiteAction, props<{ orderFromSite: string }>());
